let DialerTreeConfig = {
    baseAPIEndpoint: `${import.meta.env.VITE_APP_BASE_API_ENDPOINT}/api`,
    baseWSEndpoint: `${import.meta.env.VITE_APP_BASE_API_ENDPOINT}/ws`,
    baseAudioEndpoint: `${import.meta.env.VITE_APP_BASE_API_ENDPOINT}/audio`,
    stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
};

export default DialerTreeConfig;
